import { PatientPromotedToIntakeFeed } from "./types/patientFeeds";

export const getPatientPromotedToIntakeTitle = (
  feed: PatientPromotedToIntakeFeed,
): string =>
  feed.context.data.consultation.organization_patient.invitation_link
    .auto_promote
    ? "Auto-promoted to intake"
    : "Promoted to intake";
